export const translations = {
  FR: {
    welcome: "Bienvenue !",
    youAreAt: "Vous êtes à la",
    table: "Table",
    intro: "Commandez directement depuis votre téléphone et profitez de votre repas.",
    viewMenu: "Voir le menu",
    callWaiter: "Appeler un serveur",
    joinTable: "Rejoindre la table",
    firstName: "Prénom (facultatif)",
    firstNamePlaceholder: "Ex : Idriss",
    search: "Rechercher un plat...",
    all: "Tout",
    popular: "Coup de cœur",
    topOrdered: "Les plus commandés",
    topEmpty: "Le classement des plats les plus commandés apparaîtra dès les premières commandes.",
    unavailableSuccess: "Victime de son succès !",
    unavailableNow: "Indisponible pour le moment",
    dailySpecial: "Aujourd'hui à la carte",
    dailySpecialTag: "Plat du jour",
    cashPendingNotice: "Règlement demandé auprès de votre serveur — il arrive avec l'addition",
    restaurantNotFound: "Restaurant introuvable",
    restaurantNotFoundHint: "Vérifiez le QR code scanné ou adressez-vous au personnel.",
    add: "Ajouter",
    addedToCart: (name) => `Ajouté au panier : ${name}`,
    yourOrder: "Votre commande",
    subtotal: "Sous-total",
    order: "Commander",
    emptyCart: "Votre panier est vide",
    emptyCartHint: "Ajoutez des plats depuis le menu",
    addMore: "Ajouter autre chose",
    cooking: "Cuisson",
    supplements: "Suppléments",
    side: "Accompagnement",
    instructions: "Instructions particulières",
    instructionsPlaceholder: "Ex : sans oignons, sauce à part...",
    instrDish: "Ex : sans oignons, sauce à part…",
    instrColdDrink: "Ex : sans glaçons, sans sucre ajouté…",
    instrHotDrink: "Ex : sans sucre, lait à part…",
    instrDessert: "Ex : sans chantilly, coulis à part…",
    instrFruitSalad: "Ex : sans sirop, sans menthe…",
    instrOther: "Une préférence particulière ?",
    mixedDrinksReady: "🥤 Vos boissons / desserts arrivent, votre plat est en cuisine.",
    mixedKitchenReady: "🍽️ Votre plat est prêt, le reste arrive avec votre serveur.",
    mixedServicePending: "Une partie de votre commande est servie directement par votre serveur.",
    upsellTitle: "Avec votre plat ?",
    upsellSubtitle: "Complétez votre repas",
    noThanks: "Non merci",
    orderSent: "Commande envoyée !",
    orderReceived: "Commande reçue",
    inPreparation: "En préparation",
    ready: "Prête",
    served: "Servie",
    refused: "Commande refusée",
    trackingHint: "Suivez votre commande en temps réel",
    newOrder: "Nouvelle commande",
    callConfirmTitle: "Appeler un membre de l'équipe ?",
    callConfirmText: "Un serveur sera prévenu que vous avez besoin d'aide.",
    confirm: "Confirmer",
    cancel: "Annuler",
    edit: "Modifier",
    waiterComing: "Un membre de notre équipe arrive.",
    waiterCalled: "Serveur appelé",
    quantity: "Quantité",
    poweredBy: "Powered by NOVANEXT",
    navMenu: "Menu",
    navCart: "Ma sélection",
    navWaiter: "Serveur",
    navOrder: "Suivi",
    unavailable: "Indisponible",
    backToMenu: "Retour au menu",
    noActiveOrder: "Aucune commande en cours",
    requestAlready: "Votre demande est déjà en cours de traitement.",
    sentText: "📨 Votre commande a été envoyée au restaurant.",
    acceptedText: "🔔 Votre commande a été acceptée par le restaurant.",
    refusedText: "Commande annulée par le restaurant. Veuillez appeler votre serveur.",
    cancelledByClientText: "Commande annulée. Vous pouvez saisir une nouvelle commande ou appeler votre serveur.",
    cancelledTitle: "Commande annulée",
    cancelledByRestoTitle: "Commande annulée par le restaurant",
    cancelledHint: "Touchez l'écran pour continuer",
    addToOrder: "Ajouter des articles",
    additionHint: "Choisissez vos articles : ils seront ajoutés à votre commande en cours.",
    additionSent: "Ajout transmis au restaurant.",
    changeNotice: "Votre commande est déjà acceptée : toute modification ou retrait doit être validé par le restaurant. Rien ne change tant que la demande n'est pas acceptée.",
    changeRequestSent: "Demande de modification envoyée. En attente de validation du restaurant.",
    changePending: "Modification en attente de validation par le restaurant",
    changeAccepted: "Modification acceptée par le restaurant.",
    changeRefused: "Modification refusée par le restaurant : votre commande est inchangée.",
    changeExpired: "Table clôturée : la demande de modification a expiré.",
    additionBadge: "Ajout",
    inPrepText: "👨‍🍳 Votre commande est en préparation.",
    readyText: "🍽️ Votre commande est prête et va vous être servie.",
    servedText: "✅ Commande servie. Bon appétit !",
    descReceived: "Votre commande a bien été transmise au restaurant.",
    descPrepActive: "Nos équipes préparent actuellement votre commande.",
    descPrepPending: "En attente de validation par le restaurant.",
    descReadyActive: "Votre commande est prête, elle va bientôt vous être servie.",
    descReadyPending: "Votre commande n'est pas encore prête.",
    descServedDone: "Votre commande a été servie. Bon appétit !",
    descServedPending: "Pas encore servie.",
    ordersCount: "commandes",
    orderWord: "Commande",    navBill: "Addition",
    srvTitle: "De quoi avez-vous besoin ?",
    srvWaiter: "Appeler un serveur",
    srvWater: "De l'eau",
    srvBread: "Du pain",
    srvCutlery: "Des couverts",
    srvBill: "L'addition",
    srvOther: "Autre demande",
    srvSent: "Demande envoyée au restaurant",
    billTitle: "Votre addition",
    billEmpty: "Aucun montant à régler pour le moment.",
    billTotal: "Total de la table",
    paidSoFar: "Déjà réglé",
    remaining: "Reste à payer",
    youWillPay: "Vous allez régler",
    pickYourGuest: "Sélectionnez votre/vos prénom(s)",
    allPartsCovered: "Toutes les parts sont déjà prises en charge.",
    equalHint: "Combien de parts réglez-vous ?",
    guestsWord: "convives",
    shareSingular: "part",
    sharesPlural: "parts",
    billItems: "Détail par convive",
    tipTitle: "Ajouter un pourboire ?",
    tipNone: "Aucun",
    tipCustom: "Autre",
    tipCustomPlaceholder: "Montant du pourboire (€)",
    emailLabel: "Reçu par email (optionnel)",
    emailPlaceholder: "votre@email.com",
    billPart: "Votre part",
    tipLine: "Pourboire",
    payByPhone: "Payer sur mon téléphone",
    payAtServer: "Payer auprès du serveur",
    paySecure: "Paiement sécurisé par carte · Stripe",
    payCashHint: "Un serveur passera encaisser à votre table.",
    cashRequested: "Le serveur a été prévenu et arrive pour encaisser.",
    cashWaiting: "En attente de l'encaissement",
    paidTitle: "Paiement confirmé !",
    paidText: "Merci ! Votre table est réglée. Bonne journée.",
    payProcessing: "Vérification du paiement...",
    payFailed: "Le paiement n'a pas abouti.",
    backToTable: "Retour à ma table",
    payCancelled: "Paiement annulé.",
    retry: "Réessayer",
    reviewEyebrow: "Votre avis compte",
    reviewTitle: "Comment s'est passée votre visite ?",
    reviewSubtitle: "Attribuez une note à votre expérience.",
    reviewCommentPlaceholder: "Un mot sur votre expérience ? (facultatif)",
    reviewSubmit: "Envoyer mon avis",
    reviewPickStar: "Sélectionnez une note.",
    reviewThanks: "Merci pour votre avis !",
    reviewThanksLong: "Merci ! Votre retour nous aide à nous améliorer.",
    reviewGoogle: "Laisser un avis sur Google",
    reviewAnd: "et aussi",
    giveReview: "Donner mon avis",
  },
  EN: {
    welcome: "Welcome!",
    youAreAt: "You are at",
    table: "Table",
    intro: "Order directly from your phone and enjoy your meal.",
    viewMenu: "View the menu",
    callWaiter: "Call a waiter",
    joinTable: "Join the table",
    firstName: "First name (optional)",
    firstNamePlaceholder: "e.g. Idriss",
    search: "Search a dish...",
    all: "All",
    popular: "Staff favourite",
    topOrdered: "Most ordered",
    topEmpty: "The most-ordered ranking will appear after the first orders.",
    unavailableSuccess: "Sold out — a real hit!",
    unavailableNow: "Unavailable for now",
    dailySpecial: "Today's specials",
    dailySpecialTag: "Daily special",
    cashPendingNotice: "Payment requested from your waiter — they are on their way with the bill",
    restaurantNotFound: "Restaurant not found",
    restaurantNotFoundHint: "Check the QR code you scanned or ask the staff.",
    add: "Add",
    addedToCart: (name) => `${name} added to cart`,
    yourOrder: "Your order",
    subtotal: "Subtotal",
    order: "Place order",
    emptyCart: "Your cart is empty",
    emptyCartHint: "Add dishes from the menu",
    addMore: "Add something else",
    cooking: "Cooking",
    supplements: "Add-ons",
    side: "Side",
    instructions: "Special instructions",
    instructionsPlaceholder: "e.g. no onions, sauce on the side...",
    instrDish: "e.g. no onions, sauce on the side…",
    instrColdDrink: "e.g. no ice, no added sugar…",
    instrHotDrink: "e.g. no sugar, milk on the side…",
    instrDessert: "e.g. no whipped cream, coulis on the side…",
    instrFruitSalad: "e.g. no syrup, no mint…",
    instrOther: "Any special preference?",
    mixedDrinksReady: "🥤 Your drinks / desserts are on their way, your dish is being cooked.",
    mixedKitchenReady: "🍽️ Your dish is ready, the rest is coming with your server.",
    mixedServicePending: "Part of your order is served directly by your server.",
    upsellTitle: "With your dish?",
    upsellSubtitle: "Complete your meal",
    noThanks: "No thanks",
    orderSent: "Order sent!",
    orderReceived: "Order received",
    inPreparation: "In preparation",
    ready: "Ready",
    served: "Served",
    refused: "Order declined",
    trackingHint: "Track your order in real time",
    newOrder: "New order",
    callConfirmTitle: "Call a team member?",
    callConfirmText: "A waiter will be notified that you need help.",
    confirm: "Confirm",
    cancel: "Cancel",
    edit: "Edit",
    waiterComing: "A member of our team is on the way.",
    waiterCalled: "Waiter called",
    quantity: "Quantity",
    poweredBy: "Powered by NOVANEXT",
    navMenu: "Menu",
    navCart: "My selection",
    navWaiter: "Waiter",
    navOrder: "Tracking",
    unavailable: "Unavailable",
    backToMenu: "Back to menu",
    noActiveOrder: "No active order",
    requestAlready: "Your request is already being handled.",
    sentText: "📨 Your order has been sent to the restaurant.",
    acceptedText: "🔔 Your order has been accepted by the restaurant.",
    refusedText: "Order cancelled by the restaurant. Please call your waiter.",
    cancelledByClientText: "Order cancelled. You can place a new order or call your waiter.",
    cancelledTitle: "Order cancelled",
    cancelledByRestoTitle: "Order cancelled by the restaurant",
    cancelledHint: "Tap the screen to continue",
    addToOrder: "Add items",
    additionHint: "Pick your items: they will be added to your current order.",
    additionSent: "Addition sent to the restaurant.",
    changeNotice: "Your order is already accepted: any change or removal must be approved by the restaurant. Nothing changes until the request is accepted.",
    changeRequestSent: "Change request sent. Waiting for the restaurant's approval.",
    changePending: "Change pending restaurant approval",
    changeAccepted: "Change accepted by the restaurant.",
    changeRefused: "Change refused by the restaurant: your order is unchanged.",
    changeExpired: "Table closed: the change request has expired.",
    additionBadge: "Addition",
    inPrepText: "👨‍🍳 Your order is being prepared.",
    readyText: "🍽️ Your order is ready and will be served to you.",
    servedText: "✅ Order served. Enjoy!",
    descReceived: "Your order has been sent to the restaurant.",
    descPrepActive: "Our team is currently preparing your order.",
    descPrepPending: "Waiting for the restaurant to accept it.",
    descReadyActive: "Your order is ready — it will be served shortly.",
    descReadyPending: "Your order is not ready yet.",
    descServedDone: "Your order has been served. Enjoy!",
    descServedPending: "Not served yet.",
    ordersCount: "orders",
    orderWord: "Order",
    navBill: "Bill",
    srvTitle: "What do you need?",
    srvWaiter: "Call a waiter",
    srvWater: "Water",
    srvBread: "Bread",
    srvCutlery: "Cutlery",
    srvBill: "The bill",
    srvOther: "Other request",
    srvSent: "Request sent to the restaurant",
    billTitle: "Your bill",
    billEmpty: "Nothing to pay for now.",
    billTotal: "Table total",
    paidSoFar: "Already paid",
    remaining: "Left to pay",
    youWillPay: "You will pay",
    pickYourGuest: "Select your name(s)",
    allPartsCovered: "All parts are already covered.",
    equalHint: "How many shares are you paying?",
    guestsWord: "guests",
    shareSingular: "share",
    sharesPlural: "shares",
    billItems: "Details per guest",
    tipTitle: "Add a tip?",
    tipNone: "None",
    tipCustom: "Other",
    tipCustomPlaceholder: "Tip amount (€)",
    emailLabel: "Email receipt (optional)",
    emailPlaceholder: "you@email.com",
    billPart: "Your share",
    tipLine: "Tip",
    payByPhone: "Pay on my phone",
    payAtServer: "Pay at the counter",
    paySecure: "Secure card payment · Stripe",
    payCashHint: "A waiter will come to your table to collect payment.",
    cashRequested: "The waiter has been notified and is coming to collect.",
    cashWaiting: "Waiting for the waiter",
    paidTitle: "Payment confirmed!",
    paidText: "Thank you! Your table is settled. Have a great day.",
    payProcessing: "Verifying payment...",
    payFailed: "The payment did not go through.",
    backToTable: "Back to my table",
    payCancelled: "Payment cancelled.",
    retry: "Try again",
    reviewEyebrow: "Your feedback matters",
    reviewTitle: "How was your visit?",
    reviewSubtitle: "Rate your experience.",
    reviewCommentPlaceholder: "A word about your experience? (optional)",
    reviewSubmit: "Send my review",
    reviewPickStar: "Please pick a rating.",
    reviewThanks: "Thanks for your review!",
    reviewThanksLong: "Thank you! Your feedback helps us improve.",
    reviewGoogle: "Leave a Google review",
    reviewAnd: "and also",
    giveReview: "Give feedback",
  },
};
